import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { WalletBalanceCard } from '../buy-lotto/WalletBalanceCard';

export function PageLayout() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-brand-bg">
      <Header />
      <WalletBalanceCard />
      <main className="mx-auto max-w-7xl px-4 py-6 md:py-8">
        <Outlet />
      </main>
      <footer className="border-t border-red-100 bg-white py-6 text-center text-sm text-gray-500">
        @MUNGKORN LOTTO — ลอตเตอรี่ออนไลน์
      </footer>
    </div>
  );
}
